import * as z from 'zod';

const featureSchema = z.object({
  NEW_TRX_VIEW: z.coerce.boolean().default(true),
  NEW_EDIT_IDENTITY: z.coerce.boolean().default(false),
});

export default featureSchema.parse(process.env);
